import { Form } from 'antd';

import { MultipleDatePicker } from 'app/components/pages/Collections/CollectionDetail/CollectionSections/MultipleDatePicker/MultipleDatePicker';
import { HeaderWrapper } from 'app/components/pages/Edito/commons/Detail/HeaderWrapper/HeaderWrapper';
import { requiredRule } from 'app/utils/rules';

type Props = {
  fieldName: string | number;
};

export const DatesForm = ({ fieldName }: Props) => {
  return (
    <HeaderWrapper isBold={false} title="Dates">
      <Form.Item
        name={[fieldName, 'searchFilters', 'dates']}
        rules={[requiredRule]}
      >
        <MultipleDatePicker />
      </Form.Item>
    </HeaderWrapper>
  );
};
